/**
 * A calendar date — B10, the bid due date, is the only `date` question in
 * specification §3.
 *
 * Native <input type="date"> on purpose: iOS raises its own wheel picker, which
 * is a far better one-thumb target than anything drawn here, and the value it
 * produces is already the YYYY-MM-DD that `CalendarDate` in src/core/schema.ts
 * requires.
 */

import { useId, type ReactNode } from 'react';


export interface DateFieldProps {
  label: string;
  /** YYYY-MM-DD, or '' when unanswered. */
  value: string;
  onChange: (next: string) => void;
  min?: string;
  max?: string;
  disabled?: boolean;
}

export function DateField({
  label,
  value,
  onChange,
  min,
  max,
  disabled = false,
}: DateFieldProps): ReactNode {
  const id = useId();

  return (
    <div className="field">
<div className="field__head">
              <label className="field__label" data-legibility="question" htmlFor={id}>
          {label}
        </label>
      </div>
      <input
        id={id}
        className="field__input field__input--mono"
        type="date"
        value={value}
        disabled={disabled}
        {...(min ? { min } : {})}
        {...(max ? { max } : {})}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
}
